import useStyles from "isomorphic-style-loader/useStyles";
import React, { useCallback, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { getDelPrice, getLowerPrice, isPromotion, unitPrice } from "../../../../../../utils/product";
import { Iconfont } from "../../../../../components/icon/iconfont";
import classes from "./style.module.scss"
import _ from 'lodash'
import BottomToTop from "../../../../../components/transitions/bottom-to-top";
import { fetchProductDetails, fetchStockOutSubscribe, fetchStockOutUnSubscribe, removeWishListProduct, saveWishListProduct } from "../../../../../../api";
import { BigButton } from "../../../../../components/button";
import { IMAGE_GEEKO_LTD } from "../../../../../../constants";
import { useApp, useWebp } from "../../../../../hooks/common";
import { ColorSwiper, ImageSwiper, SizeSwiper } from "../utils/swiperComponents";
import { useDispatch, useSelector } from "react-redux";
import { setWishList } from "../../../../../../store/actions/global";
import { TOGGLE_UI_LOGIN } from "../../../../../../store/actions/ui";
import GeekoEvents from '../../../../../ads/events'
import { NormalConfirm } from "../../../../../components/alert/confirm";


const ProductEditor = props => {
    useStyles(classes)

    const {isGift, sensors, showEditor, onClose, productId, changeVariant, color, variant, product, isMain} = props

    const [selectedProduct, setSelectedProduct] = useState(undefined)
	const [selectedVariant, setSelectedVariant] = useState(undefined)
    const [productVo, setProductVo] = useState(undefined)
    const [loading, setLoading] = useState(false)
    const intl = useIntl()
    const isWebp = useWebp()
    const isApp = useApp()

    const dispatch = useDispatch()
	const global = useSelector((state) => state.global)
	const { wishlist, raffle, cart } = global

    const imagePrefix = `${IMAGE_GEEKO_LTD}${isWebp ? '/webp':''}`
    const isLiked = wishlist?.some(pId => pId === selectedProduct?.id)
    const lower = getLowerPrice(product)
	const higher = getDelPrice(product)
    let off = 0
	if (higher) {
		off = Math.round((Number(higher.amount) - Number(lower.amount)) * 100 / Number(higher.amount))
	}
    // const isNew = selectedProduct?.isNew

    const isEnabled = v => {
		if (!v) return true
		return v.status === '1' && v.inventory > 0 || (v.domesticDelivery && v.domesticDelivery.enabled && v.domesticDelivery.inventory > 0)
	}

	const isDisabled = !isEnabled(selectedVariant)

    useEffect(async () => {
		const response = await fetchProductDetails(productId)
		if (response.code === 200) {
			setProductVo(response.result)
			const selected = response.result?.products?.find(p => p.id === productId && p.variants?.[0]?.color === color) || response.result?.products?.[0]
			setSelectedProduct(selected)
            if(selected?.saved){
                dispatch(setWishList([...(wishlist || []), productId]))
            }

            if(variant){
                setSelectedVariant(variant)
            } else if(selected?.variants?.length === 1 && !!!selected?.variants?.[0]?.size || response?.result?.style === 1){
				setSelectedVariant(selected?.variants?.[0])
			}
		} else {
			alert('Error: ', response.result || 'unkown')
		}
	}, [])

    useEffect(async () => {
		if (productVo) {
			const selectProduct = productVo?.products?.find(p => p.id === productId && p.variants?.[0]?.color === color) || productVo?.products?.[0]
            setSelectedProduct(selectProduct)
            if(selectProduct?.saved){
                dispatch(setWishList([...(wishlist || []), productId]))
            }
		}
	}, [productId, color])

    const selectHandle = (product) => {
		setSelectedProduct(product)
        if(product?.saved){
            dispatch(setWishList([...(wishlist || []), product?.id]))
        }
		setSelectedVariant(null)
		if(productVo?.style === 1){
			setSelectedVariant(product?.variants?.[0])
		}
	}

	const sizeHandle = useCallback((v, p) => {
		setSelectedVariant(v)
	}, [])

	const getDescription = useCallback(desc => {
		return desc?.replace(/:[\w|\d|\-|(|)|\.]+;/g, function (value) { return '<span style="color:#999;margin-right: 5px;">' + value + ' </span>' })
	})


	const toggleWishHandle = productId => {
		const hasProduct = wishlist?.some(pId => pId === productId)
		let newWish
		if (hasProduct) {
			newWish = wishlist?.filter(pId => pId !== productId)
			removeWishListProduct(productId)
            dispatch(setWishList(newWish))
		} else {
			newWish = [...(wishlist || []), productId]
			saveWishListProduct(productId).then(data => {
				if (data.code === 300 || data.code === 600) {
					if(isApp){
						window.location.href = "chic-me://chic.me/loginRoot"
					}else{
						// window.location.href = `/i/login?redirectUrl=${window.location.href}`
						dispatch({
							type: TOGGLE_UI_LOGIN,
							payload: {
								showLogin:true,
								eventType:"收藏页",
                                callBack: async () => {
                                    saveWishListProduct(productId)
                                    dispatch(setWishList(newWish))
                                }
							}
						});
					}
				} else if(data.code === 400){
                    alert(data?.result)
                } else {
                    dispatch(setWishList(newWish))
                }
			}).catch(err => {
				if(err?.result){
					alert(err?.result)
				} else {
					console.error(err)
				}
			})
		}

		GeekoEvents.addToWishList({
			productId,
			sensors
		})
	}


	const addToCartHandle = async () => {
		if (selectedVariant) {
            // oldVariantId, newVariantId, qty,
            const oldVariant = variant ? variant: selectedProduct?.variants?.[0]
			changeVariant(oldVariant?.id, selectedVariant?.id, 1, isMain, product)
		} else {
			alert(intl.formatMessage({id:'please_select_size', defaultMessage:'Please Select a Size'}));
		}
	}

    return  <div className={classes.Editor}>
        {
            <React.Fragment>
                <div className={classes.productEditorClose}>
                    <Iconfont className={classes.maskClose} onClick={onClose}>&#xe7c9;</Iconfont>
                </div>
                <div className={classes.ImageContainer} id="product_image_seletor">
                    <ImageSwiper product={selectedProduct} />
                </div>
                <div className={classes.Bd}>
                    <div className={classes.EditorName}>
                        {/* {
                            isNew && <span className={classes.New}>New</span>
                        } */}
                        <span>{selectedProduct?.name || '-'}</span>
                    </div>

                    <div className={classes.Prices}>

                        {
                            isGift ? <span className={off > 0 ? classes.PromotionLower : classes.Lower}>{selectedProduct ? unitPrice(selectedProduct?.giftPrice || {...selectedProduct?.price, amount: '0.00'}) : '-'}</span> :<span className={off > 0 ? classes.PromotionLower : classes.Lower}>{unitPrice(lower) || '-'}</span>
                        }


                        
                        {
                            higher && <del className={classes.Del}>{unitPrice(higher)}</del>
                        }
                        {
                            off > 0 && !isGift && <span className={classes.Off}>{`-${off}%`}</span>
                        }
                    </div>

                    <div className={classes.Boxes}>
                        <div className={classes.Box}>
                            <div className={classes.Hd}>
                                <span className={classes.Title}>
                                    <FormattedMessage id="color" defaultMessage="Color" />: 
                                    {selectedVariant?.color}
                                </span>
                            </div>
                            <div className={classes.Bd}>
                                <ColorSwiper style={productVo?.style} onSelect={selectHandle} products={productVo?.products} selectedProduct={selectedProduct} selectVariant={selectedVariant}/>
                            </div>
                        </div>
                    </div>

                    {
                        productVo?.style !== 1  && !(selectedProduct?.variants?.length === 1 && !!!selectedProduct?.variants?.[0]?.size) && <div className={classes.Boxes}>
                            <div className={classes.Box}>
                                <div className={classes.Hd}>
                                    <span className={classes.Title}>
                                        <FormattedMessage id="size" defaultMessage="Size" />
                                    </span>
                                </div>
                                <div className={classes.Bd}>
                                    <SizeSwiper onSelect={sizeHandle} selectedVariant={selectedVariant} variants={selectedProduct?.variants} selectedProduct={selectedProduct} />
                                    <div className={classes.Description} dangerouslySetInnerHTML={{ __html: getDescription(selectedVariant?.description) }} />
                                </div>
                            </div>
                        </div>
                    }

                </div>
                <div className={classes.Fd}>
                    <Iconfont onClick={() => {
                        toggleWishHandle(selectedProduct?.id)
                    }} className={`${classes.CartLike} ${isLiked ? classes.Liked : ''}`}>
                        {
                            isLiked ? <React.Fragment>&#xe775;</React.Fragment> : <React.Fragment>&#xe6a2;</React.Fragment>
                        }
                    </Iconfont>

                    {
                        isDisabled ? <BigButton disabled>
                            <FormattedMessage id="sold_out" defaultMessage="Sold Out" />
                        </BigButton> : <BigButton onClick={() => {

                            if(isGift && cart?.giftCount){
                                NormalConfirm(intl.formatMessage({id:'free_gift', defaultMessage:'Free Gifts'}), intl.formatMessage({id:'multi_add', defaultMessage:'Sorry, you can only choose one item as a free gift, if you want add another item, it will replace the free gift you have already added.'}), {
                                    onConfirm: addToCartHandle,
                                    onClose: () => {props?.onClose()},
                                    cancelText: intl.formatMessage({id:'cancel', defaultMessage: 'Cancel'}),
                                    confirmText: intl.formatMessage({id:'confirm', defaultMessage: 'Confirm'})
                                })
                            }else{
                                addToCartHandle()
                            }

                        }} loading={loading} disabled={!isEnabled()}>
                            
                            <FormattedMessage id="submit" defaultMessage="Submit" />
                            
                        </BigButton>
                    }

                </div>
            </React.Fragment>
        }
    </div>
    
}

const ShopTheLookEditor = props => {
    useStyles(classes)

    const {showEditor, product, color} = props

    const isProm = isPromotion(product)

    const promotionType = isProm ? product.promotion.type : ''

    const sensors = {
        layerName: product?.layerName,
        promotionType,
        trackingRecords: product?.trackingRecords,
        dataSource: product?.dataSource,
        geekoExperimentId: product?.geekoExperimentId,
        geekoRequsestId: product?.geekoRequsestId,
        aliRequestId: product?.aliRequestId,
        aliExperimentId: product?.aliExperimentId,
        // position: position + 1
    }


    return <React.Fragment>
        <BottomToTop in={showEditor} className={classes.productEditorBox}>
            <div>
                <ProductEditor 
                    {...props}
                    isGift={false} 
                    sensors={sensors} 
                    showEditor={showEditor} 
                    onClose={() =>{props?.onClose(false)}}  
                    productId={product?.id} color={color}/>
            </div>
        </BottomToTop>
        

    </React.Fragment>
}

export default ShopTheLookEditor